
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35405',
  depVersions: {
  "documents-public-ui": "static-1.35405",
  "atom": "static-1.5475",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2878",
  "client-types": "static-1.504",
  "cssUtils": "static-1.1017",
  "customer-data-filters-ui": "static-1.41163",
  "customer-data-objects": "static-1.8087",
  "customer-data-property-utils": "static-1.8460",
  "documents-lib": "static-1.35410",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.377",
  "FormsCommonComponents": "static-1.86716",
  "FormUrlGenerator": "static-2.5108",
  "foundations-theming-specialty": "static-1.2590",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5985",
  "hs-test-utils": "static-1.8432",
  "hub-http": "static-1.6607",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12195",
  "HubStyleTokens": "static-2.11888",
  "I18n": "static-7.1690",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6843",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7546",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3284",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5776",
  "quartz": "static-1.7566",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17126",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5612",
  "react-virtualized": "static-2.110",
  "reference-resolvers": "static-1.8577",
  "reference-resolvers-lite": "static-1.8498",
  "reporting-data": "static-1.69099",
  "reporting-reports": "static-1.68775",
  "reporting-snowflake": "static-1.57715",
  "reporting-testing-lib": "static-1.11032",
  "reporting-visualizations": "static-1.61173",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9343",
  "sanitize": "static-1.4866",
  "sanitize-text": "static-1.8552",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2125",
  "signup-constants": "static-1.19780",
  "signup-ui-url-generator": "static-2.8453",
  "StyleGuideUI": "static-3.511",
  "superstore": "static-1.5155",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5141",
  "ui-addon-form-validation": "static-1.11334",
  "ui-asset-management-lib": "static-1.11497",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8834",
  "usage-tracker": "static-1.7709",
  "usage-tracker-container": "static-1.7699",
  "usage-tracker-core": "static-1.7559",
  "viral-links-lib": "static-1.7471",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10042",
  "foundations-components": "static-1.8629",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1344",
  "quartz-core": "static-1.6785",
  "quick-fetch": "static-1.4182",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5062",
  "ui-addon-i18n": "static-1.11544",
  "ui-addon-upgrades": "static-9.18489",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3843",
  "quartz-webpack": "static-1.3790",
  "foundations-assets": "static-1.5284",
  "foundations-theming": "static-1.4874",
  "hub-http-janus": "static-1.895",
  "hub-http-shared-msw-handlers": "static-1.10765",
  "hubspotter-http": "static-1.4917",
  "sassPrefix": "static-1.284",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43939",
  "customer-data-filters-ui-msw-helpers": "static-1.23598",
  "customer-data-objects-ui-components": "static-1.13425",
  "customer-data-reference-ui-components": "static-1.13563",
  "customer-data-ui-utilities": "static-1.10227",
  "events-data-lib": "static-1.642",
  "framework-builder-read-service-client": "static-1.4279",
  "hs-resources": "static-1.589",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3731",
  "inbound-db-properties-service-client": "static-1.4101",
  "multi-account-reference-resolvers": "static-1.1399",
  "onboarding-scopes": "static-1.6849",
  "onboarding-tours": "static-1.17270",
  "pulse": "static-1.1031",
  "reporting-datasets-permissions-lib": "static-1.14623",
  "segments-client-types": "static-1.11887",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2893",
  "trellis-components": "static-1.2912",
  "trellis-theming": "static-1.1373",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1241",
  "ui-business-units-lib": "static-1.9491",
  "usage-tracker-session-replay": "static-1.5395",
  "ai-components-ui-library": "static-1.9887",
  "ContentUtils": "static-1.69306",
  "customer-data-properties": "static-1.52833",
  "forms-ai-lib": "static-1.4877",
  "forms-utils-lib": "static-1.13216",
  "foundations-components-test-utils": "static-1.6112",
  "react-dnd-compat": "static-1.5009",
  "react-tinymce": "static-1.56137",
  "tinymce-config": "static-2.55263",
  "ui-gdpr-components": "static-1.10648",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3859",
  "HeadJS": "static-2.810",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3543",
  "msw": "static-1.39",
  "msw-config": "static-1.15",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.351",
  "ui-fonts": "static-1.1150",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4704",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1231",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1940",
  "external-options-client-types": "static-1.4399",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7291",
  "quartz-i18n": "static-1.1241",
  "frontend-preferences-client": "static-1.8315",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4097",
  "reporting-client-types": "static-1.2765",
  "apollo-stack-hubspot": "static-3.97",
  "growth-payments-core": "static-1.26354",
  "hubspot-apollo-client": "static-1.5269",
  "foundations-components-legacy": "static-1.1654",
  "quartz-routing": "static-1.996",
  "hs-story-utils": "static-1.9821",
  "react-flip-move": "static-1.81",
  "nested-table": "static-1.631",
  "seat-types-lib": "static-1.897",
  "timezone-utils": "static-2.5626",
  "react-create-root-preference": "static-1.87",
  "bend-plugin-foundations-components": "static-1.4898",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "opentelemetry-fe-types": "static-1.181",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.591",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.556",
  "quartz-test": "static-1.1241",
  "quartz-tracking": "static-1.945",
  "bend-plugin-chirp-manifest": "static-1.472",
  "chirp-fetch": "static-1.2295",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6537",
  "ts-schema": "static-1.4351",
  "bender-build-tools": "static-1.3472",
  "bend-plugin-foundations-theming": "static-1.3357",
  "restore-request-side-panel-lib": "static-1.1865",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5016",
  "conditional-properties-service-client": "static-1.4073",
  "crm-pipelines-api-client-types": "static-1.4404",
  "event-emitter": "static-1.1354",
  "fdsr-migration-layer": "static-1.410",
  "multi-currency-client-types": "static-1.3968",
  "getting-started-shared-tasks": "static-1.19417",
  "growth-data-modal": "static-1.6016",
  "growth-onboarding-confetti": "static-1.3459",
  "growth-onboarding-next-action-utils": "static-1.2847",
  "navigation-components": "static-1.19008",
  "onboarding-tours-client": "static-1.5485",
  "onboarding-tours-utils": "static-1.1337",
  "ui-shepherd-react": "static-3.10667",
  "ui-shepherd-tracker": "static-1.8048",
  "ui-universal-auth": "static-1.9584",
  "user-context": "static-1.5473",
  "bend-plugin-pulse": "static-1.534",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6841",
  "stylex-utils": "static-1.156",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "hubspotter-http-shared-msw-handlers": "static-1.10763",
  "magpie-lib": "static-1.5833",
  "navigation-messaging": "static-1.8335",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23401",
  "copilot-toolkit": "static-1.12003",
  "cms-field-types": "static-1.5207",
  "content-icons-ui": "static-1.2415",
  "integrations-lib": "static-1.17249",
  "calling-global-api": "static-1.65894",
  "calling-internal-common": "static-1.31717",
  "calling-lifecycle-internal": "static-1.67276",
  "calling-lifecycle-messages": "static-1.59569",
  "commerce-products-lib": "static-1.10721",
  "crm-index-visualization-core": "static-1.4652",
  "crm-links": "static-1.6695",
  "customer-data-properties-shared-msw-handlers": "static-1.10092",
  "file-manager-components": "static-1.24689",
  "formula-editor": "static-1.14902",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4482",
  "meetings-icalendar-utils-lib": "static-1.1031",
  "object-builder-ui-client": "static-1.49868",
  "pipeline-validation-client-types": "static-1.4241",
  "property-value-citations": "static-1.3447",
  "smart-data-capture-core": "static-1.301",
  "smart-property-lib": "static-1.8482",
  "tiered-pricing": "static-1.2102",
  "topics-actions-lib": "static-1.569",
  "trial-components-library": "static-1.14252",
  "ui-addon-iframeable": "static-1.9475",
  "zustand": "static-1.86",
  "final-form": "static-1.81",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20438",
  "tinymce-themes": "static-1.57233",
  "data-token-picker": "static-1.17013",
  "hub-http-contrib": "static-1.3421",
  "interframe": "static-3.5137",
  "tinymce-data": "static-1.41348",
  "tinymce-plugins": "static-1.58377",
  "ui-addon-sales-email": "static-1.5598",
  "framework-data-schema-quick-fetch": "static-1.7196",
  "ui-addon-opt": "static-4.8764",
  "hubspot-apollo-cache": "static-1.728",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.542",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.96",
  "purchase-motions-api": "static-1.6540",
  "onboarding-data-sync-lib": "static-1.2702",
  "growth-onboarding-next-action-components": "static-1.2875",
  "user-context-client": "static-1.4905",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5293",
  "nest": "static-1.631",
  "reactive-lib": "static-1.1116",
  "simple-logging-lib": "static-1.3448",
  "unified-auth-core-lib": "static-1.1380",
  "getting-started-shared-tasks-store": "static-1.18535",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1964",
  "integrations-error-boundary-lib": "static-1.14664",
  "integrations-tracking-lib": "static-1.6006",
  "native-integrations-shared-strings": "static-1.8158",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10766",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1098",
  "calling-error-reporting": "static-1.31724",
  "shared-worker-versioning": "static-1.11436",
  "calling-usage-tracker": "static-1.6931",
  "voice-sms-access-library": "static-1.2268",
  "customer-data-tracking": "static-1.7267",
  "commerce-permissions": "static-1.1172",
  "products-iframe-lib": "static-1.8741",
  "products-ui-components-shared-msw-handlers": "static-1.11147",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10848",
  "sales-views-client-types": "static-1.4652",
  "location-customization-utils-lib": "static-1.10275",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4538",
  "poll-commands": "static-1.3867",
  "video-components-external": "static-1.12303",
  "video-data-lib": "static-1.35961",
  "bark-lib": "static-1.16924",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6284",
  "react-codemirror": "static-1.11037",
  "data-agent-kit": "static-1.775",
  "feedback-loader": "static-1.29940",
  "fsm": "static-1.4149",
  "policy-lib": "static-1.7202",
  "react-colorpicker": "static-2.10608",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10911",
  "embedded-academy-lib": "static-1.15766",
  "hubs-service-types": "static-1.1657",
  "nudge-client-utils": "static-1.3281",
  "salesImages": "static-1.656",
  "FileManagerLib": "static-1.40329",
  "NamespacedHubStyle": "static-2.9316",
  "FileManagerCore": "static-1.40188",
  "content-assistance-lib": "static-1.8317",
  "layout-dnd-components": "static-1.13100",
  "layout-dnd-utils": "static-1.12075",
  "ui-addon-emoji-picker": "static-1.10264",
  "ui-brand-identity-lib": "static-1.16748",
  "InboxConnectUtils": "static-4.15710",
  "meetings-connect-utils-lib": "static-1.8010",
  "breeze-engine-chat-components": "static-1.942",
  "breeze-engine-core": "static-1.1242",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3406",
  "adobe-sign-auth-lib": "static-1.627",
  "ads-unified-auth-lib": "static-1.1687",
  "custom-vendor-connection-lib": "static-1.148",
  "google-sheets-integration-lib": "static-1.1191",
  "microsoft-drive-auth-lib": "static-1.348",
  "surveymonkey-integration-lib": "static-1.700",
  "slack-ui-library": "static-1.10794",
  "calling-orchestration-schema": "static-1.37045",
  "crm-record-cards-service-types": "static-1.3827",
  "content-media-composition-data-lib": "static-1.13435",
  "content-media-compositions": "static-2.17442",
  "media-bridge-lib": "static-1.19531",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16522",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4902",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15226",
  "nudge-custom-function-registry": "static-1.3038",
  "nudge-renderer-utils": "static-1.3357",
  "whisper-core-api": "static-1.7492",
  "audio-components": "static-1.6465",
  "FileManagerImages": "static-1.37840",
  "video-components": "static-1.14305",
  "breeze-artifacts-sdk": "static-1.625",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4911",
  "video-embed": "static-1.36795",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29466",
  "ContentData": "static-1.69381",
  "layout-data-lib": "static-1.10400",
  "academy-service-client": "static-1.4088",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4790",
  "trellis-ecosystem": "static-1.7742",
  "ui-addon-react-router-dom": "static-1.9925",
  "wootric-nps": "static-1.7253",
  "social-insights-client-types": "static-1.22792",
  "outpost": "static-1.4532",
  "growth-onboarding-feedback-components": "static-1.6981",
  "advanced-menus-core": "static-1.15696",
  "advanced-menus-lib": "static-1.12511",
  "ExportDialog": "static-6.10773",
  "ui-memberships-settings-lib": "static-1.35002",
  "marketplace-ui-apps-core": "static-1.19448",
  "marketplace-ui-common": "static-1.20916",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15695",
  "simple-menus-lib": "static-1.17212",
  "settings-ui-lib": "static-1.12924",
  "developer-experience-shared-components": "static-1.10931",
  "immutable-less": "static-1.5046",
  "marketplace-ui-client-types": "static-1.18323",
  "ui-addon-integrations-directory-panel": "static-2.8386",
  "ui-extensibility-client-types": "static-1.4312",
  "ai-settings-ui-library": "static-1.8464",
  "nav-meta": "static-1.30645",
  "ui-product-approvals-common": "static-1.1356",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3674"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35405",
  "atom": "/atom/static-1.5475",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2878",
  "client-types": "/client-types/static-1.504",
  "cssUtils": "/cssUtils/static-1.1017",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41163",
  "customer-data-objects": "/customer-data-objects/static-1.8087",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8460",
  "documents-lib": "/documents-lib/static-1.35410",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.377",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86716",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5108",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2590",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5985",
  "hs-test-utils": "/hs-test-utils/static-1.8432",
  "hub-http": "/hub-http/static-1.6607",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12195",
  "HubStyleTokens": "/HubStyleTokens/static-2.11888",
  "I18n": "/I18n/static-7.1690",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6843",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7546",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3284",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5776",
  "quartz": "/quartz/static-1.7566",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17126",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5612",
  "react-virtualized": "/react-virtualized/static-2.110",
  "reference-resolvers": "/reference-resolvers/static-1.8577",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8498",
  "reporting-data": "/reporting-data/static-1.69099",
  "reporting-reports": "/reporting-reports/static-1.68775",
  "reporting-snowflake": "/reporting-snowflake/static-1.57715",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11032",
  "reporting-visualizations": "/reporting-visualizations/static-1.61173",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9343",
  "sanitize": "/sanitize/static-1.4866",
  "sanitize-text": "/sanitize-text/static-1.8552",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2125",
  "signup-constants": "/signup-constants/static-1.19780",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8453",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "superstore": "/superstore/static-1.5155",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5141",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11334",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11497",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8834",
  "usage-tracker": "/usage-tracker/static-1.7709",
  "usage-tracker-container": "/usage-tracker-container/static-1.7699",
  "usage-tracker-core": "/usage-tracker-core/static-1.7559",
  "viral-links-lib": "/viral-links-lib/static-1.7471",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10042",
  "foundations-components": "/foundations-components/static-1.8629",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1344",
  "quartz-core": "/quartz-core/static-1.6785",
  "quick-fetch": "/quick-fetch/static-1.4182",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5062",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11544",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18489",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3843",
  "quartz-webpack": "/quartz-webpack/static-1.3790",
  "foundations-assets": "/foundations-assets/static-1.5284",
  "foundations-theming": "/foundations-theming/static-1.4874",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10765",
  "hubspotter-http": "/hubspotter-http/static-1.4917",
  "sassPrefix": "/sassPrefix/static-1.284",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43939",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23598",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13425",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13563",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10227",
  "events-data-lib": "/events-data-lib/static-1.642",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4279",
  "hs-resources": "/hs-resources/static-1.589",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3731",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4101",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1399",
  "onboarding-scopes": "/onboarding-scopes/static-1.6849",
  "onboarding-tours": "/onboarding-tours/static-1.17270",
  "pulse": "/pulse/static-1.1031",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14623",
  "segments-client-types": "/segments-client-types/static-1.11887",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2893",
  "trellis-components": "/trellis-components/static-1.2912",
  "trellis-theming": "/trellis-theming/static-1.1373",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1241",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9491",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5395",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9887",
  "ContentUtils": "/ContentUtils/static-1.69306",
  "customer-data-properties": "/customer-data-properties/static-1.52833",
  "forms-ai-lib": "/forms-ai-lib/static-1.4877",
  "forms-utils-lib": "/forms-utils-lib/static-1.13216",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6112",
  "react-dnd-compat": "/react-dnd-compat/static-1.5009",
  "react-tinymce": "/react-tinymce/static-1.56137",
  "tinymce-config": "/tinymce-config/static-2.55263",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10648",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3859",
  "HeadJS": "/HeadJS/static-2.810",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3543",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.15",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.351",
  "ui-fonts": "/ui-fonts/static-1.1150",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4704",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1231",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1940",
  "external-options-client-types": "/external-options-client-types/static-1.4399",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7291",
  "quartz-i18n": "/quartz-i18n/static-1.1241",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8315",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4097",
  "reporting-client-types": "/reporting-client-types/static-1.2765",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "growth-payments-core": "/growth-payments-core/static-1.26354",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5269",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1654",
  "quartz-routing": "/quartz-routing/static-1.996",
  "hs-story-utils": "/hs-story-utils/static-1.9821",
  "react-flip-move": "/react-flip-move/static-1.81",
  "nested-table": "/nested-table/static-1.631",
  "seat-types-lib": "/seat-types-lib/static-1.897",
  "timezone-utils": "/timezone-utils/static-2.5626",
  "react-create-root-preference": "/react-create-root-preference/static-1.87",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4898",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.181",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.591",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.556",
  "quartz-test": "/quartz-test/static-1.1241",
  "quartz-tracking": "/quartz-tracking/static-1.945",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.472",
  "chirp-fetch": "/chirp-fetch/static-1.2295",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6537",
  "ts-schema": "/ts-schema/static-1.4351",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3357",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1865",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5016",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4073",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4404",
  "event-emitter": "/event-emitter/static-1.1354",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.410",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3968",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19417",
  "growth-data-modal": "/growth-data-modal/static-1.6016",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3459",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2847",
  "navigation-components": "/navigation-components/static-1.19008",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5485",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1337",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10667",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8048",
  "ui-universal-auth": "/ui-universal-auth/static-1.9584",
  "user-context": "/user-context/static-1.5473",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.534",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6841",
  "stylex-utils": "/stylex-utils/static-1.156",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10763",
  "magpie-lib": "/magpie-lib/static-1.5833",
  "navigation-messaging": "/navigation-messaging/static-1.8335",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23401",
  "copilot-toolkit": "/copilot-toolkit/static-1.12003",
  "cms-field-types": "/cms-field-types/static-1.5207",
  "content-icons-ui": "/content-icons-ui/static-1.2415",
  "integrations-lib": "/integrations-lib/static-1.17249",
  "calling-global-api": "/calling-global-api/static-1.65894",
  "calling-internal-common": "/calling-internal-common/static-1.31717",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67276",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59569",
  "commerce-products-lib": "/commerce-products-lib/static-1.10721",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4652",
  "crm-links": "/crm-links/static-1.6695",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10092",
  "file-manager-components": "/file-manager-components/static-1.24689",
  "formula-editor": "/formula-editor/static-1.14902",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4482",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1031",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49868",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4241",
  "property-value-citations": "/property-value-citations/static-1.3447",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.301",
  "smart-property-lib": "/smart-property-lib/static-1.8482",
  "tiered-pricing": "/tiered-pricing/static-1.2102",
  "topics-actions-lib": "/topics-actions-lib/static-1.569",
  "trial-components-library": "/trial-components-library/static-1.14252",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9475",
  "zustand": "/zustand/static-1.86",
  "final-form": "/final-form/static-1.81",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20438",
  "tinymce-themes": "/tinymce-themes/static-1.57233",
  "data-token-picker": "/data-token-picker/static-1.17013",
  "hub-http-contrib": "/hub-http-contrib/static-1.3421",
  "interframe": "/interframe/static-3.5137",
  "tinymce-data": "/tinymce-data/static-1.41348",
  "tinymce-plugins": "/tinymce-plugins/static-1.58377",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5598",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7196",
  "ui-addon-opt": "/ui-addon-opt/static-4.8764",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.728",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.542",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.96",
  "purchase-motions-api": "/purchase-motions-api/static-1.6540",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2702",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2875",
  "user-context-client": "/user-context-client/static-1.4905",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5293",
  "nest": "/nest/static-1.631",
  "reactive-lib": "/reactive-lib/static-1.1116",
  "simple-logging-lib": "/simple-logging-lib/static-1.3448",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1380",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18535",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1964",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14664",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6006",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8158",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10766",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1098",
  "calling-error-reporting": "/calling-error-reporting/static-1.31724",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11436",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6931",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2268",
  "customer-data-tracking": "/customer-data-tracking/static-1.7267",
  "commerce-permissions": "/commerce-permissions/static-1.1172",
  "products-iframe-lib": "/products-iframe-lib/static-1.8741",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11147",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10848",
  "sales-views-client-types": "/sales-views-client-types/static-1.4652",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10275",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4538",
  "poll-commands": "/poll-commands/static-1.3867",
  "video-components-external": "/video-components-external/static-1.12303",
  "video-data-lib": "/video-data-lib/static-1.35961",
  "bark-lib": "/bark-lib/static-1.16924",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6284",
  "react-codemirror": "/react-codemirror/static-1.11037",
  "data-agent-kit": "/data-agent-kit/static-1.775",
  "feedback-loader": "/feedback-loader/static-1.29940",
  "fsm": "/fsm/static-1.4149",
  "policy-lib": "/policy-lib/static-1.7202",
  "react-colorpicker": "/react-colorpicker/static-2.10608",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10911",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15766",
  "hubs-service-types": "/hubs-service-types/static-1.1657",
  "nudge-client-utils": "/nudge-client-utils/static-1.3281",
  "salesImages": "/salesImages/static-1.656",
  "FileManagerLib": "/FileManagerLib/static-1.40329",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9316",
  "FileManagerCore": "/FileManagerCore/static-1.40188",
  "content-assistance-lib": "/content-assistance-lib/static-1.8317",
  "layout-dnd-components": "/layout-dnd-components/static-1.13100",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12075",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10264",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16748",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15710",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8010",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.942",
  "breeze-engine-core": "/breeze-engine-core/static-1.1242",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3406",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.627",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1687",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.148",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1191",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.348",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.700",
  "slack-ui-library": "/slack-ui-library/static-1.10794",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37045",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3827",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13435",
  "content-media-compositions": "/content-media-compositions/static-2.17442",
  "media-bridge-lib": "/media-bridge-lib/static-1.19531",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16522",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4902",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15226",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3038",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3357",
  "whisper-core-api": "/whisper-core-api/static-1.7492",
  "audio-components": "/audio-components/static-1.6465",
  "FileManagerImages": "/FileManagerImages/static-1.37840",
  "video-components": "/video-components/static-1.14305",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.625",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4911",
  "video-embed": "/video-embed/static-1.36795",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29466",
  "ContentData": "/ContentData/static-1.69381",
  "layout-data-lib": "/layout-data-lib/static-1.10400",
  "academy-service-client": "/academy-service-client/static-1.4088",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4790",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7742",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9925",
  "wootric-nps": "/wootric-nps/static-1.7253",
  "social-insights-client-types": "/social-insights-client-types/static-1.22792",
  "outpost": "/outpost/static-1.4532",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6981",
  "advanced-menus-core": "/advanced-menus-core/static-1.15696",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12511",
  "ExportDialog": "/ExportDialog/static-6.10773",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35002",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19448",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20916",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15695",
  "simple-menus-lib": "/simple-menus-lib/static-1.17212",
  "settings-ui-lib": "/settings-ui-lib/static-1.12924",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10931",
  "immutable-less": "/immutable-less/static-1.5046",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18323",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8386",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4312",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8464",
  "nav-meta": "/nav-meta/static-1.30645",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1356",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3674"
}
};
